import { useState } from 'react';

import { useAsyncState } from '@lender/utils';

import { IS_DEVELOPMENT } from 'constants/envs';

export const useAsyncStateSafeStrictMode = IS_DEVELOPMENT ? useState : useAsyncState;
